export const defaultDevice: DeviceService = {
  sendMessage(): void {},
  updateWidget(): void {},
  canInstallApp: (): boolean => false,
  isNative: (): boolean => false,
};
